export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        chainId: entity.chainId,
        branchId: entity.branchId || null,
        accessKey: entity.accessKey || '',
        tableNumber: entity.tableNumber || null,        
    };
};
